import { ShieldCheck, Pencil } from "lucide-react";
import { Reveal } from "../components/motion";

const SECTIONS = [
  ["Age guidelines", "Recommended age guidance will be published here once product testing and final compliance requirements are complete. Bedtime Buddies are designed for preschool and elementary-age children."],
  ["Not for infant sleep", "Bedtime Buddies are not intended for infant sleep environments. Never place a Buddy in a crib or bassinet."],
  ["Charging safety", "Charge only with the included cable, away from the sleep area, and never leave charging overnight unattended. Full charging instructions ship with your Buddy."],
  ["Battery information", "Battery specifications and care details will be published once final product engineering is complete."],
  ["Weighted components", "The softly weighted arms are designed for preschool and elementary-age children. Final weight specifications will be published after product testing."],
  ["Bluetooth & electronics", "The electronics module is enclosed inside the plush and designed for low-power nighttime use. Full technical safety details ship with your Buddy."],
  ["Cleaning", "Surface clean the plush outer with a damp cloth and mild soap. Never machine wash the electronics module. Full care instructions ship with every Buddy."],
  ["Inspection", "Check your Buddy regularly for wear. If seams loosen or the electronics module is damaged, retire it from bedtime use and contact us."],
  ["Supervision", "As with any children's product, follow the age guidance and use your Buddy as directed in the included instructions."],
];

export default function Safety() {
  return (
    <div className="bg-cream" data-testid="safety-page">
      <div className="mx-auto max-w-4xl px-6 py-16 lg:py-24">
        <Reveal className="text-center">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-blush">
            <ShieldCheck className="text-pinkdeep" size={30} />
          </span>
          <h1 className="mt-6 font-display text-4xl font-medium text-navy sm:text-5xl">Safety, in plain language.</h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-navy/60" data-testid="safety-intro">
            Bedtime Buddies are designed as comfort companions for children who meet the recommended age and product-use guidelines. Always follow all safety instructions provided with your Buddy. Not intended for infant sleep environments.
          </p>
        </Reveal>
        <div className="mt-14 space-y-4">
          {SECTIONS.map(([title, body], i) => (
            <Reveal key={title} delay={0.03 * i}>
              <div className="card-soft p-7" data-testid={`safety-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <div className="flex items-center justify-between gap-4">
                  <h2 className="font-display text-xl font-semibold text-navy">{title}</h2>
                  <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-navy/30"><Pencil size={10} /> Editable</span>
                </div>
                <p className="mt-2.5 text-sm leading-relaxed text-navy/60">{body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
